module.exports = __webpack_public_path__ + "img/xlsx.2cec12ed.png";